import { Stack } from "@mantine/core";
import React from "react";
import Profile from "./Profile";

const User = () => {
  return (
    <Stack>
      <Profile />
    </Stack>
  );
};

export default User;
